import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {AuthService, AuthSession} from "./auth/services/auth.service";
import {NgIf} from "@angular/common";
import {LoginComponent} from "./auth/components/login/login.component";
import {LayoutMasterComponent} from "./core/layout-master/layout-master.component";
import {ApiService} from "./services/api.service";
import {QuickCardComponent} from "./core/quick-card/quick-card.component";
import {DebugSetterComponent} from "./core/debug-setter/debug-setter.component";
import {interval, Subscription} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgIf, LoginComponent, LayoutMasterComponent, QuickCardComponent, DebugSetterComponent, MatIconModule, RouterLink],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class AppComponent implements OnInit, OnDestroy {

  readonly sessionExpirationAutoRedirectInSeconds = 60
  routerEventsSub?: Subscription
  currentUrl?: string
  sessionSnackbarAlertShown = false
  session?: AuthSession
  sessionSub?: Subscription
  sessionTimerChanges?: Subscription

  constructor(
    readonly snackBar: MatSnackBar,
    readonly router: Router,
    protected authService: AuthService,
    protected api: ApiService) {
    this.routerEventsSub = this.router.events
      .subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.currentUrl = e.url
        }
      })
  }

  ngOnDestroy(): void {
    this.sessionSub?.unsubscribe()
    this.sessionSub = undefined
    this.sessionTimerChanges?.unsubscribe()
    this.sessionTimerChanges = undefined
    this.routerEventsSub?.unsubscribe()
    this.routerEventsSub = undefined
  }

  ngOnInit(): void {
    this.session = this.authService.getSession()
    this.sessionSub = this.authService.sessionState.subscribe((r) => {
      this.session = r
      this.sessionSnackbarAlertShown = false
    })
    this.sessionTimerChanges = interval(10000).subscribe({
      next: () => {
        if (this.session) {
          const expirationAt = this.authService.getExpirationDate(this.session.identity)
          const expirationInSeconds = (expirationAt.getTime() - new Date().getTime()) / 1000
          if (expirationInSeconds < this.sessionExpirationAutoRedirectInSeconds) {
            if (!this.sessionSnackbarAlertShown) {
              this.snackBar.open(
                'Your session expires shortly. You are being redirected for sign-in',
                'Dismiss',
                {
                  politeness: 'polite',
                  duration: 7000,
                }
              )
              this.sessionSnackbarAlertShown = true
            }
            if (this.currentUrl && ! this.currentUrl.startsWith('/auth')) {
              this.router.navigate(['/auth'], {
                queryParams: {
                  returnUrl: encodeURIComponent(this.currentUrl),
                  reason: 'tokenExpiration'
                }
              }).finally(()=> {})
            }
            else {
              this.router.navigate(['/auth'], {
                queryParams: {
                  reason: 'tokenExpiration'
                }
              }).finally(()=> {})
            }
          }
        }
      }
    })
  }

  hasRole(r: string): boolean {
    if (this.session?.identity?.claims?.length) {
      const match = this.session!.identity!.claims!.find(
        c => c.type == 'role' && c.value == r
      )
      return match != undefined
    }
    return false
  }
}
